<template>
  <PhHeart
    v-if="filled"
    weight="fill"
    :size="size"
    class="self-center text-teal-500 hover:text-slate-400"
  />
  <PhHeart
    v-else
    :size="size"
    class="self-center text-slate-400 hover:text-emerald-500"
  />
</template>

<script setup>
import { PhHeart } from "@phosphor-icons/vue";

defineProps({
  filled: { type: Boolean, default: false },
  size: { type: Number, default: 32 },
});
</script>
